import { Box, Button, FormControl, Grid, TextField, Select, MenuItem, InputLabel } from '@mui/material';
import { usePosMappingsContext } from '../../context/PosMappingsContext';
import { SearchSm } from '../../../../assets';
import { theme } from '../../../../theme'; 
 

export function PosSkuMapping() {
  const { 
    t, 
    skuSearch,
    storeSearch,
    itemType,
    handleSkuSearchChange,
    handleStoreSearchChange,
    handleItemTypeChange,
    searchPOSMapping,
    clearAll,
  } = usePosMappingsContext();

  return (
    <Box sx={{ mt: 1 }}>
      <Box
        sx={{
          border: '1px solid',
          borderColor: theme.palette.custom.gray[300],
          py: '0px',
          textAlign: 'left',
        }}
      > 
        <Grid
          container
          spacing={5}
          sx={{
            alignItems: 'flex-end',
            borderColor: theme.palette.custom.gray[300],
            px: '8px',
            py: '12px',
          }}
        >
          <Grid item
            xs={12}
            md={2}>
            <FormControl fullWidth
              size="small">
              <TextField
                size="small"
                id="sku-search"
                label={t('skuSearch')}
                variant="outlined"
                value={skuSearch}
                onChange={handleSkuSearchChange}
              />
            </FormControl>
          </Grid>

          <Grid item
            xs={12}
            md={2}>
            <FormControl fullWidth
              size="small">
              <TextField
                size="small"
                id="store-search"
                label={t('storeSearch')}
                variant="outlined"
                value={storeSearch}
                onChange={handleStoreSearchChange}
              />
            </FormControl>
          </Grid>

          <Grid item
            xs={12}
            md={2}>
            <FormControl fullWidth
              size="small">
              <InputLabel id="item-type-label">{t('itemType')}</InputLabel>
              <Select
                labelId="item-type-label"
                id="item-type-select"
                value={itemType ?? ''}
                label={t('itemType')}
                onChange={(e) => handleItemTypeChange(e.target.value === '' ? undefined : Number(e.target.value))}
              >
                <MenuItem value="">{t('all')}</MenuItem>
                <MenuItem value={1}>{t('standalone')}</MenuItem>
                <MenuItem value={2}>{t('milk')}</MenuItem>
                <MenuItem value={3}>{t('bomMilk')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item
            xs={12}
            md={2}>
            <Button variant="secondary"
              size="lg"
              onClick={clearAll}
              fullWidth>
              {t('clearAll')}
            </Button>
          </Grid>

          <Grid item
            xs={12}
            md={2}>
            <Button
              variant="primary"
              size="lg"
              onClick={searchPOSMapping}
              startIcon={<SearchSm />}
              fullWidth
            >
              {t('search')}
            </Button>
          </Grid>
        </Grid> 
      </Box>
    </Box>
  );
}
